/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotificationByIdResponse } from '../../models/get-notification-by-id-response';

export interface GetNotification$Params {

/**
 * The notificationId for the notication to be fetched
 */
  notificationId: string;
}

export function getNotification(http: HttpClient, rootUrl: string, params: GetNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationByIdResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotification.PATH, 'get');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotificationByIdResponse>;
    })
  );
}

getNotification.PATH = '/notification/{notificationId}';
